export enum RuntimeConfigurationValueType {
    String = 'String',
    Boolean = 'Boolean',
    Integer = 'Integer',
    Decimal = 'Decimal',
    Date = 'Date',
    DateTime = 'DateTime',
    StringList = 'StringList',
    IntList = 'IntList',
    Json = 'Json',
}

export enum RuntimeConfigurationInputMode {
    Auto = 'Auto',
    Radio = 'Radio',
    Select = 'Select',
}

export enum RuntimeConfigurationNotFoundReason {
    KeyNotFound = 'KeyNotFound',
    VersionNotFound = 'VersionNotFound',
    Deleted = 'Deleted',
}

/** UI'da oluşturma ve filtre için kullanılan tipler (kodda string olarak saklanır, parse sizde). */
export const RUNTIME_CONFIGURATION_UI_VALUE_TYPES = [
    RuntimeConfigurationValueType.String,
    RuntimeConfigurationValueType.Json,
] as const;

export const RUNTIME_CONFIGURATION_VALUE_TYPE_OPTIONS = Object.values(RuntimeConfigurationValueType);
